import React, { useState } from "react";
import NoFooterModal from "../Common/NoFooterModal";
import Button from "sushiweb/Button";
import styled from "styled-components";
import { Box, drawerClasses } from "@mui/material";
import Input from "sushiweb/InputTypes/Input";
import { useDispatch } from "react-redux";
import useMutation from "../../hooks/useMutation";
import CommunicationHubApis from "../../services/api/CommunicationHub";
import useForm from "../Common/FormComponent/useForm";
import { setStatus } from "../../store/actions/User";
import FormComponent from "../Common/FormComponent/FormComponent";
import {
  createNewElementForm,
  elementType,
} from "./constants";

const ForceCompleteElementDialog = ({ options, tag }) => {
  const [openForceCompleteModal, setOpenForceCompleteModal] = useState(false);
  const [driverId, setDriverId] = useState("");
  const [elementId, setElementId] = useState("");

  const dispatch = useDispatch();
  const { mutate: forceComplete, isPending } = useMutation(
    CommunicationHubApis.forceComplete
  );

  const handleForceComplete = async () => {
    try {
      await forceComplete({
        element_type: form.values["elementType"],
        element_id: elementId,
        driver_id: driverId,
      });
      setOpenForceCompleteModal(false)
    } catch (err) {
      console.log(err);
      dispatch(
        setStatus({
          message: "Something went wrong",
          type: "error",
        })
      );
    }
  }
  const form = useForm({
    elementType: elementType[0].value,
  });
  return (
    <>
      <Button
        onClick={() => setOpenForceCompleteModal(true)}
        className="sushi-btn mr-10"
        appearance="outline"
        data-testid="hubForceCompleteBtn"
      >
        Force complete
      </Button>
      {openForceCompleteModal && (
        <NoFooterModal
          handleClose={() => setOpenForceCompleteModal(false)}
          header
          heading="Force Complete"
        >
          <Box display={"flex"} gap={1} alignItems={"center"}>
            {createNewElementForm.map((item) => (
              <FormComponent
                config={item}
                form={form}
                key={item.id}
                otherOptions={options?.element_types}
              />
            ))}
          </Box>
          <ElementDetails>
           <p>Element ID</p>
              <Input
               id="sushi-input"
               name="forceCompleteElementId"
               label="Element ID"
               type="text"
               value={elementId}
               onChange={(e) => setElementId(e)}
              />
          </ElementDetails>
          <ElementDetails>
            <p>Driver ID</p>
              <Input
                id="sushi-input"
                name="forceComplete"
                label="Driver ID"
                type="text"
                value={driverId}
                onChange={(e) => setDriverId(e)}
              />
          </ElementDetails>
          <Box mt={4} display={"flex"} justifyContent={"end"}>
            <Button
              onClick={() =>
                handleForceComplete()
              }
              className="sushi-btn"
              disabled={isPending}
            >
              Confirm
            </Button>
          </Box>
        </NoFooterModal>
      )}
    </>
  );
};

const ElementDetails =styled.div`
  {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
  align-items: center;
  p {
    margin-bottom: 10px;
  }
  #sushi-input {
    width: 280px;
    margin-bottom: unset;
    padding-right: 0px;
  }
  }
`;

export default ForceCompleteElementDialog;
